export default __webpack_public_path__ + "static/media/dispatched_default_connected_selected.27254969.svg";